
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';
/**
 * @Description: 菜单
 * @author gan
 * @date: 2020/12/17 11:09
 * @attribute name 名称
 * @attribute path 路径
 * @attribute icon 图标
 * @attribute children 子菜单
 * @attribute menuKey 菜单key(需要唯一，用于获取权限)
 */
import store from "@/store/store";
import {commonLocalStorage, handleCommonMenuData} from "@/utils/common";
import {setConfigCharacters} from "@/utils/enum";

// 生成基础菜单结构，后续再根据最新配置做菜单隐藏和名称处理。
const createBaseMenuList = () => {
  return [
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006562'),
      icon: '&#xe67b;',
      type: 'statistics',
      path: '/statistics',
      menuKey: 'yms_statistics',
    },
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006967'),
      icon: '&#xe749;',
      type: 'productList',
      children: [
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007888'),
          path: '/selfOperatedProductsList',
          menuKey: 'yms_selfOperatedProductsList',
          children: [
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003337'),
              path: '/selfOperatedProductsViewSku',
              menuKey: 'yms_selfOperatedProductsViewSku',
              menuHide: true // 菜单不展示
            },
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007889'),
              path: '/selfOperatedProductsDetails',
              menuKey: 'yms_selfOperatedProductsDetails',
              menuHide: true // 菜单不展示
            }
          ]
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007890'),
          path: '/productList',
          menuKey: 'yms_productList',
          children: [
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003337'),
              path: '/ymsViewSku',
              menuKey: 'yms_ymsViewSku',
              menuHide: true // 菜单不展示
            },
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007891'),
              path: '/productDetails',
              menuKey: 'yms_productDetails',
              menuHide: true // 菜单不展示
            }
          ]
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003303'),
          path: '/category',
          menuKey: 'yms_category',
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007892'),
          path: '/sizeTemplateManage',
          menuKey: 'yms_sizeTemplateManage',
          children: [
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007893'),
              path: '/updateSizeTemplate',
              menuKey: 'yms_updateSizeTemplate',
              menuHide: true // 菜单不展示
            }
          ]
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007894'),
          path: '/newProductReviewList',
          menuKey: 'yms_newProductReviewList',
          children: [
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007895'),
              path: '/newProductReviewDetails',
              menuKey: 'yms_newProductReviewDetails',
              menuHide: true // 菜单不展示
            },
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003340'),
              path: '/findSimilarProducts',
              menuKey: 'yms_findSimilarProducts',
              menuHide: true // 菜单不展示
            }
          ]
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007896'),
          path: '/productReviewForSaleList',
          menuKey: 'yms_productReviewForSaleList',
          children: [
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007897'),
              path: '/productReviewForSaleDetails',
              menuKey: 'yms_productReviewForSaleDetails',
              menuHide: true // 菜单不展示
            },
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003340'),
              path: '/findSimilarProducts',
              menuKey: 'yms_findSimilarProducts',
              menuHide: true // 菜单不展示
            }
          ]
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002935'),
          path: '/itemAttributes',
          menuKey: 'yms_itemAttributes'
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003304'),
          path: '/productLabel',
          menuKey: 'yms_productLabel'
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007898'),
          path: '/productSalesPriceConfig',
          menuKey: 'yms_productSalesPriceConfig'
        },
      ]
    },
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001535'),
      icon: '&#xe665;',
      type: 'orderList',
      children: [
        {
          name: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001887')}`,
          path: '/orderList',
          menuKey: 'yms_orderList',
          children: [
            {
              name: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006135')}`,
              path: '/orderListDetails',
              menuKey: 'yms_orderListDetails',
              menuHide: true // 菜单不展示
            },
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007899'),
              path: '/supplierOrderDetails',
              menuKey: 'yms_supplierOrderDetails',
              menuHide: true // 菜单不展示
            }
          ]
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007900'),
          path: '/distributorStockList',
          menuKey: 'yms_distributorStockList'
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007901'),
          path: '/supplierStockList',
          menuKey: 'yms_supplierStockList',
          children: [
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007902'),
              path: '/supplierStockOrderDetails',
              menuKey: 'yms_supplierStockOrderDetails',
              menuHide: true // 菜单不展示
            }
          ]
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002934'),
          path: '/supplierOrders',
          menuKey: 'yms_supplierOrders'
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007903'),
          path: '/orderCollectionAccount',
          menuKey: 'yms_orderCollectionAccount'
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004648'),
          path: '/orderPaymentReconciliation',
          menuKey: 'yms_orderPaymentReconciliation'
        },
      ]
    },
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004788'),
      icon: '&#xe679;',
      type: 'wms',
      children: [
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002926'),
          path: '/wms/inventoryLevels',
          menuKey: 'yms_wms_inventoryLevels'
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007904'),
          children: [
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007905'),
              path: '/billLadingManage',
              menuKey: 'yms_billLadingManage',
              children: [
                {
                  name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007906'),
                  path: '/billLadingManageDetails',
                  menuKey: 'yms_billLadingManageDetails',
                  menuHide: true // 菜单不展示
                }
              ]
            },
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002647'),
              path: '/billWarehousing',
              menuKey: 'yms_billWarehousing'
            },
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002648'),
              path: '/commoditySorting',
              menuKey: 'yms_commoditySorting'
            },
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002925'),
              path: '/commoditySticker',
              menuKey: 'yms_commoditySticker'
            },
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002651'),
              path: '/commodityShelves',
              menuKey: 'yms_commodityShelves'
            }
          ]
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001743'),
          children: [
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004785'),
              path: '/wms/generateOrderList',
              menuKey: 'yms_wms_generateOrderList'
            },
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007907'),
              path: '/generateOrderDetails',
              menuKey: 'yms_generateOrderDetails',
              menuHide: true // 菜单不展示
            },
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007899'),
              path: '/generateSupplierOrderDetails',
              menuKey: 'yms_generateSupplierOrderDetails',
              menuHide: true // 菜单不展示
            },
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007908'),
              path: '/wms/pickList',
              menuKey: 'yms_wms_pickList'
            },
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004975'),
              path: '/wms/pickListDetails',
              menuKey: 'yms_wms_pickListDetails',
              menuHide: true // 菜单不展示
            },
          ]
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007909'),
          children: [
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007910'),
              path: '/wms/sortOrderSetting',
              menuKey: 'yms_wms_sortOrderSetting'
            },
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002652'),
              path: '/wms/sorting',
              menuKey: 'yms_wms_sorting'
            },
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002654'),
              path: '/wms/packWorking',
              menuKey: 'yms_wms_packWorking'
            },
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002655'),
              path: '/sortingOut',
              menuKey: 'yms_sortingOut'
            },
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007911'),
              path: '/handoverSheetManage',
              menuKey: 'yms_handoverSheetManage',
              children: [
                {
                  name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007912'),
                  path: '/handoverSheetManageDetails',
                  menuKey: 'yms_handoverSheetManageDetails',
                  menuHide: true // 菜单不展示
                }
              ]
            }
          ]
        }
      ]
    },
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007913'),
      icon: '&#xe668;',
      type: 'supplierList',
      children: [
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007914'),
          path: '/supplierList',
          menuKey: 'yms_supplierList'
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007915'),
          path: '/supplierAuditList',
          menuKey: 'yms_supplierAuditList'
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007916'),
          path: '/supplierLevel',
          menuKey: 'yms_supplierLevel'
        }
      ]
    },
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007917'),
      icon: '&#xe699;',
      type: 'distributorList',
      children: [
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007918'),
          path: '/customerList',
          menuKey: 'yms_customerList',
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003182'),
          path: '/customerLabel',
          menuKey: 'yms_customerLabel',
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003181'),
          path: '/customerGroups',
          menuKey: 'yms_customerGroups',
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003183'),
          path: '/customerGrade',
          menuKey: 'yms_customerGrade'
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007919'),
          path: '/tuokeLink',
          menuKey: 'yms_tuokeLink'
        }
      ]
    },
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001536'),
      icon: '&#xe668;',
      type: 'supplierBillManage',
      children: [
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000495'),
          path: '/platformBill',
          menuKey: 'yms_platformBill',
          children: [
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007920'),
              path: '/platformBillDetails',
              menuKey: 'yms_platformBillDetails',
              menuHide: true // 菜单不展示
            }
          ]
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007921'),
          path: '/supplierBillManage',
          menuKey: 'yms_supplierBillManage',
          children: [
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007922'),
              path: '/supplierBillDetails',
              menuKey: 'yms_supplierBillDetails',
              menuHide: true // 菜单不展示
            }
          ]
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000494'),
          path: '/customerBill',
          menuKey: 'yms_customerBill',
          children: [
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007923'),
              path: '/customerBillDetails',
              menuKey: 'yms_customerBillDetails',
              menuHide: true // 菜单不展示
            }
          ]
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002936'),
          path: '/logisticsBill',
          menuKey: 'yms_logisticsBill',
          children: [
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007924'),
              path: '/logisticsBillDetails',
              menuKey: 'yms_logisticsBillDetails',
              menuHide: true // 菜单不展示
            }
          ]
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002937'),
          path: '/warehouseBill',
          menuKey: 'yms_warehouseBill',
          children: [
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007925'),
              path: '/warehouseBillDetails',
              menuKey: 'yms_warehouseBillDetails',
              menuHide: true // 菜单不展示
            }
          ]
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003683'),
          path: '/financialJournal',
          menuKey: 'yms_financialJournal'
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007926'),
          path: '/rechargeRecord',
          menuKey: 'yms_rechargeRecord'
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007927'),
          path: '/passwordManage',
          menuKey: 'yms_passwordManage'
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002930'),
          path: '/subsidyReview',
          menuKey: 'yms_subsidyReview'
        }
      ]
    },
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007928'),
      icon: '&#xe68e;',
      type: 'logisticsManage',
      children: [
        {
          name: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001581')}`,
          path: '/ymsLogistics',
          menuKey: 'yms_ymsLogistics'
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007929'),
          path: '/basicLogistics',
          menuKey: 'yms_basicLogistics'
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007930'),
          path: '/smartLogisticsRule',
          menuKey: 'yms_smartLogisticsRule'
        },
      ]
    },
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001551'),
      icon: '&#xe68f;',
      type: 'warehouseManage',
      children: [
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007931'),
          path: '/warehouseManage',
          menuKey: 'yms_warehouseManage'
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007932'),
          path: '/reservoirManage',
          menuKey: 'yms_reservoirManage'
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007933'),
          path: '/locationManage',
          menuKey: 'yms_locationManage'
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007934'),
          path: '/messageNotification',
          menuKey: 'yms_messageNotification'
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002210'),
          path: '/exchangeRateConfig',
          menuKey: 'yms_exchangeRateConfig'
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007935'),
          path: '/containerManage',
          menuKey: 'yms_containerManage'
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007936'),
          path: '/containerSettings',
          menuKey: 'yms_containerSettings'
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007937'),
          path: '/addressLibraryManage',
          menuKey: 'yms_addressLibraryManage'
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007938'),
          path: '/processConfiguration',
          menuKey: 'yms_processConfiguration'
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007939'),
          path: '/iossTaxRateSetting',
          menuKey: 'yms_iossTaxRateSetting'
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007940'),
          path: '/systemConfigList',
          menuKey: 'yms_systemConfigList'
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007941'),
          children: [
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001335'),
              path: '/declarationRules',
              menuKey: 'yms_declarationRules'
            }
          ]
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001535'),
          children: [
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007942'),
              path: '/automaticDistributionRules',
              menuKey: 'yms_automaticDistributionRules'
            }
          ]
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007943'),
          path: '/thirdPartyPlatformList',
          menuKey: 'yms_thirdPartyPlatformList',
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007944'),
          path: '/deliveryLocationManage',
          menuKey: 'yms_deliveryLocationManage',
        },
      ]
    },
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007945'),
      icon: '&#xe68b;',
      type: 'helpCenter',
      children: [
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000027'),
          path: '/helpCenter',
          menuKey: 'yms_helpCenter',
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007946'),
          path: '/questionnaireInvestigation',
          menuKey: 'yms_questionnaireInvestigation',
          children: [
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002879'),
              path: '/questionnaireStatistics',
              menuKey: 'yms_questionnaireStatistics',
              menuHide: true // 菜单不展示
            },
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002974'),
              path: '/addQuestionnaire',
              menuKey: 'yms_addQuestionnaire',
              menuHide: true // 菜单不展示
            },
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007947'),
              path: '/editQuestionnaire',
              menuKey: 'yms_editQuestionnaire',
              menuHide: true // 菜单不展示
            }
          ]
        },
        /*{
          name: '操作指引',
          path: '/operatingInstructions',
          menuKey: 'yms_operatingInstructions',
        },*/
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001126'),
          id: 'toSystemAnnouncement',
          jurisdictionHide: true, // 不需要权限判断
          hideMenu: true, // 在权限设置中不展示此菜单
          externalLink: true, // 是否跳转到外部系统的标识
          menuKey: 'yms_systemAnnouncement',
        },
      ]
    },
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007948'),
      icon: '&#xe691;',
      type: 'dataCenter',
      children: [
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002928'),
          path: '/deliveryDetails',
          menuKey: 'yms_deliveryDetails',
        }
      ]
    },
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007949'),
      icon: '&#xe66a;',
      type: 'activityManage',
      children: [
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007950'),
          path: '/siteManage',
          menuKey: 'yms_siteManage',
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007951'),
          path: '/activityManage',
          menuKey: 'yms_activityManage',
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007952'),
          path: '/editActivity',
          menuKey: 'yms_editActivity',
          menuHide: true // 菜单不展示
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007953'),
          path: '/advertisingManage',
          menuKey: 'yms_advertisingManage',
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005067'),
          path: '/rotationChart',
          menuKey: 'yms_rotationChart',
          menuHide: true // 菜单不展示
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005045'),
          path: '/vajraDistrict',
          menuKey: 'yms_vajraDistrict',
          menuHide: true // 菜单不展示
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005068'),
          path: '/topAdvertisingSpace',
          menuKey: 'yms_topAdvertisingSpace',
          menuHide: true // 菜单不展示
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005069'),
          path: '/sideAdvertisingSpace',
          menuKey: 'yms_sideAdvertisingSpace',
          menuHide: true // 菜单不展示
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005070'),
          path: '/infoAdvertisingSpace',
          menuKey: 'yms_infoAdvertisingSpace',
          menuHide: true // 菜单不展示
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003842'),
          path: '/subsidyRules',
          menuKey: 'yms_subsidyRules',
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007954'),
          path: '/distributorFeeAllocation',
          menuKey: 'yms_distributorFeeAllocation',
        },
      ]
    },
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000037'),
      path: '/messageCenter',
      icon: '&#xe8be;',
      menuKey: 'yms_messageCenter',
      jurisdictionHide: true, // 不需要权限判断
      type: 'messageCenter',
      children: [
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007955'),
          path: '/messageMailboxes',
          menuKey: 'yms_messageMailboxes',
          menuHide: true // 菜单不展示
        },
      ]
    },
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007956'),
      icon: '&#xe693;',
      path: '/employeeList',
      menuKey: 'yms_employeeList',
      type: 'employeeList',
    },
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007957'),
      icon: '&#xe664;',
      type: 'importTask',
      children: [
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007958'),
          path: '/importTask',
          menuKey: 'yms_importTask'
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007959'),
          path: '/exportTask',
          menuKey: 'yms_exportTask'
        }
      ]
    }
  ];
};

export const getYmsMenu = () => {
  let ymsMenuList = createBaseMenuList();
  const configurationItemInfo = commonLocalStorage.getItem('configurationItemInfo') ?? store.state.configurationItemInfo;
  const saasConfigurationItems = commonLocalStorage.getItem('saasConfigurationItems') ?? store.state.saasConfigurationItems;
  
  // 订单线下支付配置停用时，不显示【订单管理--订单收款账户、订单支付对账】菜单
  const offlinePaymentDisabled = Number(configurationItemInfo?.offlinePayment) === 0;
  if (offlinePaymentDisabled) {
    ymsMenuList = handleCommonMenuData(ymsMenuList, {
      hideMenuKeys: [
        'yms_orderCollectionAccount',
        'yms_orderPaymentReconciliation'
      ],
      hideTypes: ['orderList']
    });
  }
  
  // 关闭平台自营商品模式配置时，不显示【商品管理--平台自营商品，供应商商品”修改为“商品列表、商品详情、查看SKU”】菜单
  const platformSelfOperatedProductModelSaasDisabled = Number(saasConfigurationItems?.platformSelfOperatedProductModelSaas) === 0;
  if (platformSelfOperatedProductModelSaasDisabled) {
    ymsMenuList = handleCommonMenuData(ymsMenuList, {
      hideMenuKeys: [
        'yms_selfOperatedProductsList'
      ],
      hideTypes: ['productList']
    });
  }
  
  return ymsMenuList;
};

export default {
  get menu() {
    return getYmsMenu();
  }
};
